export default "__VITE_ASSET__c017a280__"